import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statCards = [
    {
      label: 'Total Applications',
      value: stats?.total,
      icon: 'FileText',
      color: 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400',
      bgColor: 'bg-blue-50 dark:bg-blue-900/10'
    },
    {
      label: 'Under Review',
      value: stats?.underReview,
      icon: 'Eye',
      color: 'bg-yellow-100 text-yellow-600 dark:bg-yellow-900/30 dark:text-yellow-400',
      bgColor: 'bg-yellow-50 dark:bg-yellow-900/10'
    },
    {
      label: 'Interviews',
      value: stats?.interviews,
      icon: 'Calendar',
      color: 'bg-indigo-100 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400',
      bgColor: 'bg-indigo-50 dark:bg-indigo-900/10'
    },
    {
      label: 'Offers',
      value: stats?.offers,
      icon: 'CheckCircle',
      color: 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400',
      bgColor: 'bg-green-50 dark:bg-green-900/10'
    },
    {
      label: 'Response Rate',
      value: `${stats?.responseRate}%`,
      icon: 'TrendingUp',
      color: 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400',
      bgColor: 'bg-purple-50 dark:bg-purple-900/10'
    },
    {
      label: 'Avg. Response Time',
      value: `${stats?.avgResponseTime} days`,
      icon: 'Clock',
      color: 'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400',
      bgColor: 'bg-orange-50 dark:bg-orange-900/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      {statCards?.map((stat, index) => (
        <div key={index} className={`${stat?.bgColor} rounded-lg p-4 border border-border`}>
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${stat?.color} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} />
            </div>
          </div>
          <div className="text-2xl font-bold text-foreground mb-1">{stat?.value}</div>
          <div className="text-sm text-muted-foreground">{stat?.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;